const certificateModal = () => {
  const certificateIcons = document.querySelectorAll('[data-file-certificate]')
  const certificateLinks = document.querySelectorAll(
    '[data-file-certificate-notification]',
  )

  const isModal = document.querySelectorAll('[data-modal-certificate]')
  const modalBody = document.querySelectorAll('[data-modal-body]')
  const closeIcon = document.querySelectorAll('[data-modal-close-icon]')
  const closeButton = document.querySelectorAll('[data-modal-close-button]')

  const isModalSubscribe = document.querySelector('[data-modal-subscribe]')
  const isModalSubscribeErr = document.querySelector(
    '[data-modal-subscribe-error]',
  )

  const isModalFeedback = document.querySelector(
    '[data-modal-feedback-success]',
  )
  const isModalFeedbackErr = document.querySelector(
    '[data-modal-feedback-error]',
  )

  const toggleFunc = (index) => {
    if (isModal[index]) {
      isModal[index].classList.toggle('is-invisible')
      isModal[index].classList.toggle('is-layout-locked')
    }
  }

  const setFocus = (index) => {
    if (isModal[index]) {
      closeIcon[index].focus()
    }
  }

  const closeModalFunc = (el) => {
    if (isModalFeedback && isModalFeedback.contains(el)) {
      isModalFeedback.classList.add('is-invisible')
      isModalFeedback.classList.remove('is-layout-locked')

      window.location.reload()

      return
    }

    if (isModalFeedbackErr && isModalFeedbackErr.contains(el)) {
      isModalFeedbackErr.classList.add('is-invisible')
      isModalFeedbackErr.classList.remove('is-layout-locked')

      return
    }

    if (isModalSubscribe && isModalSubscribe.contains(el)) {
      isModalSubscribe.classList.add('is-invisible')
      isModalSubscribe.classList.remove('is-layout-locked')

      return
    }

    if (isModalSubscribeErr && isModalSubscribeErr.contains(el)) {
      isModalSubscribeErr.classList.toggle('is-invisible')
      isModalSubscribeErr.classList.toggle('is-layout-locked')

      return
    } else {
      isModal.forEach((item) => {
        if (item.contains(el)) {
          item.classList.add('is-invisible')
          item.classList.remove('is-layout-locked')
        }
      })
    }
  }

  certificateIcons &&
    certificateIcons.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (isModal[index]) {
          toggleFunc(index)
          setFocus(index)
        }
      })
    })

  certificateLinks &&
    certificateLinks.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (isModal[index]) {
          toggleFunc(index)
          setFocus(index)
        }
      })
    })

  isModal &&
    isModal.forEach((item, index) => {
      item.addEventListener('click', (event) => {
        if (!modalBody[index].contains(event.target)) {
          item.classList.add('is-invisible')
          item.classList.remove('is-layout-locked')
        }
      })
    })

  closeIcon &&
    closeIcon.forEach((item) => {
      item.addEventListener('click', () => {
        closeModalFunc(item)
      })
    })

  closeButton &&
    closeButton.forEach((item) => {
      item.addEventListener('click', () => {
        closeModalFunc(item)
      })
    })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      isModal &&
        isModal.forEach((item) => {
          item.classList.add('is-invisible')
          item.classList.remove('is-layout-locked')
        })
    }
  })
}

document.addEventListener('DOMContentLoaded', certificateModal)
